import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import LanguageSlider from "../../shared-components/language-slider/language-slider";
import { formatMessage } from "../../translations/format-message";
import { EmailTabEnum } from "../../constants/enums/email-tab-enum";
import emailTypeEnum from "../../constants/enums/email-type-enum";
import AddUpdateEmailSetting from "./components/add-update-email-setting";
import { useStore } from "../../contexts/store-provider";
import "./email-management.css"

const EmailManagement = (props: any) => {
  const { emailManagementStore } = useStore();
  const {
    setEmailTypeEnum,
    resetGetHQEmailSettingsDetail,
    resetGetStoreEmailSettingsDetail,
     resetStoreDetails
  } = emailManagementStore;
  const [activeTab, setActiveTab] = useState<EmailTabEnum | string>(
    EmailTabEnum.ReservationReminder
  );

  useEffect(()=>{
    return(()=>{
      setActiveTab(EmailTabEnum.ReservationReminder);
      setEmailTypeEnum(emailTypeEnum.ReservationReminder);
      resetStoreDetails();
    })
  },[])

  const handleTabSelect = async (key: string | null) => {
    if (!key || key === activeTab) return;
    if (key) {
      resetGetHQEmailSettingsDetail();
      resetGetStoreEmailSettingsDetail();
      setActiveTab(key);
    }
    setEmailTypeEnum(
      key === EmailTabEnum.ReservationReminder
        ? emailTypeEnum.ReservationReminder
        : key === EmailTabEnum.VisitingThanks
        ? emailTypeEnum.VisitingThanks
        : emailTypeEnum.HappyBirthday
    );
  };

  return (
    <>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="email_management" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="various_settings" />
                </li>
                <li className="breadcrumb-item" aria-current="page">
                  <FormattedMessage id="email_management" />
                </li>
              </ol>
            </div>
          </div>
          <div className="col-6">
            <ul className="add-list">
              <li>
                <LanguageSlider />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container-fluid mt-4 p-0">
        <div className="card email-management">
          <div className="row g-0">
            <div className="col-12 main-content">
              <Tabs
                activeKey={activeTab}
                onSelect={handleTabSelect}
                id="booking"
                className="mb-3"
              >
                <Tab
                  eventKey={EmailTabEnum.ReservationReminder}
                  title={formatMessage("reminder")}
                ></Tab>

                <Tab
                  eventKey={EmailTabEnum.VisitingThanks}
                  title={formatMessage("thank_you")}
                ></Tab>

                <Tab
                  eventKey={EmailTabEnum.HappyBirthday}
                  title={formatMessage("birthday")}
                ></Tab>
              </Tabs>
              <AddUpdateEmailSetting />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(EmailManagement);
